module.exports = __webpack_public_path__ + "img/header-img.28d63bfa.png";